import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter, Link } from 'react-router-dom';
import flightBanner from "../../assets/img/flight-banner.png";
import JourneyDate from "./components/journeyDate";
import "./index.css";
import axios from "axios";
import IconSearch from "@material-ui/icons/Search";
import Footer from "../Flight/components/footer";
import Typography from "@material-ui/core/Typography";

import GuestCard from "./components/GuestCard";
import HotelOrRental from "./components/HotelOrRental";
import City from "./City";
import HotelCard from "./HotelCard";
import moment from "moment";
import Loader from "../Loader/Loader";
import MapView from "./components/MapView";
import TravelMenu from "../User/Header/TravelMenu";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { Input } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "4%",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
    paddingTop: "30%",
    // backgroundColor: "var(--darker)",
    // [theme.breakpoints.down("sm")]: {
    //   paddingTop: "18%",
    // },
  },

  main2: {
    paddingTop: "8%",

    // backgroundColor: "var(--darker)",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "2%",
      paddingRight: "2%",
      paddingTop: "29%",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "2%",
      paddingRight: "2%",
      paddingTop: "14%",
    },
  },
  container: {
    backgroundColor: "var(--white)",
    borderRadius: 5,
  },
  formSelect: {
    fontSize: ".875rem",
    padding: "0.5%",
  },
  flightBG: {
    backgroundImage: `url('${flightBanner}')`,
    borderRadius: "10px",
    height: '232px',
  },
}));


function Hotels(props) {
  const classes = useStyles();
  const [cityId, setCityId] = useState(null);
  const [cityName, setCityName] = useState(null);
  const [selectedDepartureDate, setSelectedDepartureDate] = useState(null);
  const [selectedArrivalDate, setSelectedArrivalDate] = useState(null);
  const [hotels, setHotels] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [loading, setLoading] = useState(false);
  const [adults, setAdults] = React.useState(1);
  const [childrens, setChildrens] = React.useState(0);
  const [position, setPosition] = React.useState(false);
  const [room, setRoom] = React.useState(1);

  const handlePassengerUpdate = (data) => {
    if (data) {
      setAdults(data.adults);
      setChildrens(data.childrens);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDepartureDate(date);
  };
  const handleArrivalDateChange = (date) => {
    setSelectedArrivalDate(date);
  };

  const DateStringToDate = (d) => {
    let date = new Date(d);
    return date;
  };

  const searchHotels = async () => {
    if (!selectedDepartureDate || !selectedArrivalDate || !cityId || !adults)
      return;
    // setLoading(true);
    var queryParam = `/hotels/search-hotels-properties?check_in_date=${moment(
      selectedDepartureDate
    ).format("yyyy-MM-DD")}&check_out_date=${moment(selectedArrivalDate).format(
      "yyyy-MM-DD"
    )}&location=${cityId}&adult_count=${adults}&child_count=${childrens}&source_market=AU&room_count=${room}`;

    let currency = props.currency;

    if (currency) queryParam += `&currency=${currency}`;
    props.history.push(queryParam)

    // let response2 = await axios.get(queryParam);
    // if (response2 && response2.data && response2.data.data) {
    //   var data = response2.data.data;
    //   if(data.status !== 'complete'){
    //     setTimeout(searchHotels, 3000)
    //   }else{
    //     setLoading(false);
    //   }
    //   if (data && data.hotels && data.hotels.length > 0) {
    //     setHotels(data.hotels);
    //     let _markers = data.hotels.map(item => ({ id: item.meta_data.id, title: item.meta_data.name, lat: parseFloat(item.meta_data.latitude), lng: parseFloat(item.meta_data.longitude) }));
    //     console.log('_markers', _markers)
    //     setMarkers(_markers);
    //   }
    // }

  };

  const listenScrollEvent = (e) => {
    if (window.scrollY > 460) {
      setPosition(true)
    } else {
      setPosition(false)
    }
  };

  useEffect(() => {
    {
      window.addEventListener("scroll", listenScrollEvent);
      if (hotels && hotels.length > 0) {
        let _markers = hotels.map(item => ({ id: item.meta_data.id, title: item.meta_data.name, lat: parseFloat(item.meta_data.latitude), lng: parseFloat(item.meta_data.longitude) }));
        setMarkers(_markers);
      }
    }
  }, []);


  const onHotelHover = (data) => {
    setSelectedMarker(data)
  }

  const handleChange = (v) => {
    setRoom(v)
  }

  return (
    <>
      <div className="hotels" style={{ backgroundColor: "var(--backgroundcolor)", color: "var(--backgroundcolor)" }}>
        <TravelMenu activeIndex={2} />
        <div style={{ paddingTop: '80px', minHeight: "42vh" }}>
          <div className={`container ${classes.container} cardSearchBox`}>

            <div style={{ padding: "10px", marginTop: "25px" }}>
              <div className="row">
                <div className="col-sm-12 col-xs-12 col-md-4">
                  <City
                    destination={{
                      code: cityId,
                      name: cityName,
                    }}
                    onDestinationChange={(d) => {
                      setCityId(d?._id);
                      setCityName(d?._id);
                    }}
                  />
                </div>

                <div
                  className="col-xs-12 col-sm-12 col-md-4"
                  style={{ padding: 0, marginBottom: '10px' }}
                >
                  <JourneyDate
                    value={{
                      start:
                        selectedDepartureDate &&
                        moment(selectedDepartureDate).toDate(),
                      end:
                        selectedArrivalDate &&
                        moment(selectedArrivalDate).toDate(),
                    }}
                    onStartChange={(d) => {
                      setSelectedDepartureDate(DateStringToDate(d));
                    }}
                    onEndChange={(d) => {
                      setSelectedArrivalDate(DateStringToDate(d));
                    }}
                  />
                </div>
                <div
                  className="col-sm-3 col-xs-3 col-md-1"
                  style={{ padding: 0 }}
                >
                  <GuestCard
                    fullWidth
                    adults={adults}
                    childrens={childrens}
                    infants={0}
                    onChange={handlePassengerUpdate}
                  />
                </div>
                <div
                  className="col-sm-6 col-xs-6 col-md-3"
                  style={{ padding: 0, maxWidth: "75%" }}
                >
                  <div>
                    <div className="action-button" style={{ marginTop: '2px' }}>
                      <Select disableUnderline={true}
                        style={{ fontSize: 16, paddingLeft:'9px' }}
                        value={room}
                        displayEmpty
                        className='currency-select'
                        input={<Input />}
                        inputProps={{ style: { fontSize: 16, paddingLeft:'9px' } }}
                        onChange={(e) => handleChange(e.target.value)}>
                        <MenuItem value="1">1 Room</MenuItem>
                        <MenuItem value="2">2 Rooms</MenuItem>
                        <MenuItem value="3">3 Rooms</MenuItem>
                        <MenuItem value="4">4 Rooms</MenuItem>
                        <MenuItem value="5">5 Rooms</MenuItem>
                        <MenuItem value="6">6 Rooms</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                height: "32px",
              }}
              onClick={searchHotels}
            >
              <div className="search-button">
                <IconSearch style={{ color: "#fff" }} />{" "}
                <Typography component="span"> Search</Typography>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className={`${classes.main}`} style={{ paddingTop: 60 }}>
            <div
              className={`container `}
              style={{ marginBottom: 40, padding: "0px" }}
            >
              <div className="row">
                <div className="col-sm-12 col-xs-12 col-md-6">
                  <div className="row">
                    {hotels &&
                      hotels.length > 0 &&
                      hotels.map((hotel) => {
                        return (
                          <div
                            className="col-sm-12 col-xs-12 col-md-12"
                            style={{ marginBottom: "20px" }}
                          >
                            <HotelCard hotel={hotel} onHotelHover={data => onHotelHover(data)} />
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className={`col-sm-12 col-xs-12 col-md-6 ${position ? 'map-position' : ''}`}>

                  {markers &&
                    markers.length > 0 && <MapView markers={markers} selectedMarker={selectedMarker} />}
                </div>
              </div>
            </div>
          </div>
          <hr></hr>
          <Footer />
        </div>
        <Loader show={loading} />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    currency: state.flight.currency ? state.flight.currency : "",
    auth: state.user.auth
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //   login: (creds) => dispatch(login(creds))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Hotels);
